import React from 'react';
import {BrowserRouter as Router, Navigate, Route, Routes, useLocation} from 'react-router-dom';
import './App.css';
import PropertyDescription from './components/property/property-description/property-description';
import Footer from './components/footer/footer';
import Header from './components/header/header';
import Main from './components/main/main';
import Signup from './components/auth/signup/signup';
import Login from './components/auth/login/login';
import Logout from './components/auth/logout/logout';
import PasswordReset from './components/auth/password/password-reset/password-reset';
import AuthContextProvider from './shared/services/auth-context/auth-context';
import SignupVerification from './components/auth/signup/signup-verification/signup-verification';
import ProtectedRoute from './guards/protected_route';
import ForgotPassword from './components/auth/password/forgot-password/forgot-password';
import AddProperty from './components/property/add-property/add-property';
import PropertyList from './components/property/property-list/property-list';
import DeveloperList from './components/developer/developer-list/developer-list';
import PrivacyPolicy from "./components/privacy-policy/privacy-policy";
import EventDescription from "./components/event/event-description/event-description";
import AboutUs from "./components/about/about-us";
import DeviceContextProvider from "./shared/services/device-context/device-context";
import EventList from "./components/event/event-list/event-list";
import ResetPosition from "./shared/components/reset-position/reset-position";
import NotFound from "./components/not-found/not-found";

function RouteList() {
  const location = useLocation();
  const hideHeaderFooterPaths = ['/signup', '/signup/verification', '/login', '/password/forgot', '/password/reset'];
  const hideHeaderFooter = hideHeaderFooterPaths.some((path) => {
    return location.pathname.includes(path);
  });

  return (
      <div style={{minHeight: '100vh', display: 'flex', flexDirection: 'column'}}>
        <DeviceContextProvider>
          {!hideHeaderFooter && <Header/>}
          <div style={{flexGrow: 1, paddingBottom: '20px'}}>
            <AuthContextProvider>
              <ResetPosition />
              <Routes>
                <Route path='/signup'
                       Component={Signup}/>
                <Route path='/signup/verification/:verificationCode'
                       Component={SignupVerification}/>
                <Route path='/password/forgot'
                       Component={ForgotPassword}/>
                <Route path='/password/reset/:resetCode'
                       Component={PasswordReset}/>
                <Route path='/logout'
                       Component={Logout}/>
                <Route path='/'
                       Component={Main}/>
                <Route path='/developer/list'
                       Component={DeveloperList}/>
                <Route path='/property/list'
                       Component={PropertyList}/>
                <Route path='/property/:property_id/details'
                       Component={PropertyDescription}/>
                <Route path='/privacy-policy'
                       Component={PrivacyPolicy}/>
                <Route path='/about-us'
                       Component={AboutUs}/>
                <Route path='/event/list'
                       Component={EventList}/>
                <Route path='/event/:event_code'
                       Component={EventDescription}/>
                <Route Component={ProtectedRoute}>
                  <Route path='/login'
                         Component={Login}/>
                  <Route path='/property/add'
                         Component={AddProperty}/>
                </Route>
                <Route path='/not-found'
                       Component={NotFound}/>
                <Route path='*' element={<Navigate to="/not-found"/>}/>
              </Routes>
            </AuthContextProvider>
          </div>
          {!hideHeaderFooter && <Footer/>}
        </DeviceContextProvider>
      </div>
  );
}

function App() {
  return (
    <Router>
      <RouteList/>
    </Router>
  );
}

export default App;
